import { Component, Input, ViewChild } from '@angular/core';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  standalone: true,
  selector: 'shc-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  imports: [MatExpansionModule, MatIconModule, CommonModule],
  styleUrls: ['./expansion-panel.component.scss'],
  animations: [
    trigger('iconRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(90deg)' })),
      transition('collapsed <=> expanded', animate('200ms ease-in-out'))
    ])
  ],
  host: {
    class: 'shc-expansion-panel',
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    '[class.expansion-panel-active]': 'expanded'
  }
})
export class ExpansionPanelComponent {
  @ViewChild('panel') panel: MatExpansionPanel;

  @Input() expanded: boolean; // Allow initializing panel as expanded
}
